<div class="case-type-editor">
  <ts-loading-overlay *ngIf="loading$ | async" [message]="'info.loading_data'"></ts-loading-overlay>
  <ts-loading-overlay *ngIf="saving$ | async" [message]="'alert.saving'"></ts-loading-overlay>

  <header class="case-type-editor__header">
    <h1>{{ 'title.case_type_editor' | translate }}</h1>
  </header>

  <div *ngIf="error$ | async as errorKey" class="case-type-editor__error" data-cy="case-type-load-error">
    <i class="ri-error-warning-line" aria-hidden="true"></i>
    <span>{{ errorKey | translate }}</span>
  </div>

  <div class="case-type-editor__field">
    <label class="case-type-editor__field-label" for="case-type-editor-name">
      {{ 'case_type_editor.label.name' | translate | uppercase }}
    </label>
    <input
      id="case-type-editor-name"
      class="ts-input"
      type="text"
      data-cy="case-type-name"
      [formControl]="nameControl"
      [class.has-error]="!!(nameError$ | async)"
    />
    <div class="case-type-editor__error" *ngIf="nameError$ | async as nameErrorKey" data-cy="case-type-name-error">
      <i class="ri-error-warning-line" aria-hidden="true"></i>
      <span>{{ nameErrorKey | translate }}</span>
    </div>
  </div>

  <div class="case-type-editor__field">
    <label class="case-type-editor__field-label" for="case-type-editor-description">
      {{ 'case_type_editor.label.description' | translate | uppercase }}
    </label>
    <textarea
      id="case-type-editor-description"
      class="ts-textarea"
      rows="3"
      data-cy="case-type-description"
      [formControl]="descriptionControl"
    ></textarea>
  </div>

  <hr class="case-type-editor__separator" />

  <section class="case-type-editor__section">
    <ts-case-data-manager></ts-case-data-manager>
  </section>

  <hr class="case-type-editor__separator" />

  <section class="case-type-editor__section">
    <ts-method-type-manager></ts-method-type-manager>
  </section>

  <div class="case-type-editor__actions">
    <button
      type="button"
      class="btn btn-outline-primary case-type-editor__action"
      data-cy="case-type-cancel"
      (click)="onCancel()"
    >
      <i class="ri-close-fill"></i>
      {{ 'button.cancel' | translate }}
    </button>
    <!-- Never disabled on invalid (clicking save with a missing name paints the
         error); only disabled while a load or save is in flight. -->
    <button
      type="button"
      class="btn btn-primary case-type-editor__action"
      data-cy="case-type-save"
      [disabled]="(loading$ | async) || (saving$ | async)"
      (click)="onSave()"
    >
      <i class="ri-save-line"></i>
      {{ 'button.save_case_type' | translate }}
    </button>
  </div>
</div>
